import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TravelDocumentSalesModel,
  TravelDocumentSalesMutationVoidInput,
  TravelDocumentSalesMutationInput,
  TravelDocumentSalesMutationUpdateInput,
  TravelDocumentSalesStatusMutationUpdateInput,
  UploadTravelDocumentSalesMutationUpdate,
  CompleteTravelDocumentSalesMutation,
  RevertCompleteTravelDocumentSalesMutation,
} from './model';

export function useCreateTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationInput
  >,
): UseMutationResult<
  ApiResult<TravelDocumentSalesModel>,
  ApiError,
  TravelDocumentSalesMutationInput
> {
  return useMutation<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'document-sales',
      method: 'POST',
      classType: TravelDocumentSalesModel,
      body,
    });
  }, options);
}

export function useUpdateTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationUpdateInput
  >,
): UseMutationResult<
  ApiResult<TravelDocumentSalesModel>,
  ApiError,
  TravelDocumentSalesMutationUpdateInput
> {
  return useMutation<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}`,
      method: 'PUT',
      // classType: any,
      body: body.body,
    });
  }, options);
}

export function useVoidTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationVoidInput
  >,
): UseMutationResult<
  ApiResult<TravelDocumentSalesModel>,
  ApiError,
  TravelDocumentSalesMutationVoidInput
> {
  return useMutation<
    ApiResult<TravelDocumentSalesModel>,
    ApiError,
    TravelDocumentSalesMutationVoidInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}/void`,
      method: 'PATCH',
      // classType: any,
    });
  }, options);
}

export function useUpdateStatusTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    TravelDocumentSalesStatusMutationUpdateInput
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  TravelDocumentSalesStatusMutationUpdateInput
> {
  return useMutation<
    ApiResult<any>,
    ApiError,
    TravelDocumentSalesStatusMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}/update-document-status`,
      method: 'PATCH',
      body: body.body,
      //classType:any
    });
  }, options);
}

export function useUploadTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    UploadTravelDocumentSalesMutationUpdate
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  UploadTravelDocumentSalesMutationUpdate
> {
  return useMutation<
    ApiResult<any>,
    ApiError,
    UploadTravelDocumentSalesMutationUpdate
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}/upload-documents`,
      method: 'PATCH',
      body: body.body,
      //classType:any
    });
  }, options);
}

export function useCompleteTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    CompleteTravelDocumentSalesMutation
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  CompleteTravelDocumentSalesMutation
> {
  return useMutation<
    ApiResult<any>,
    ApiError,
    CompleteTravelDocumentSalesMutation
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}/complete`,
      method: 'PATCH',
    });
  }, options);
}

export function useRevertCompleteTravelDocumentSales(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    RevertCompleteTravelDocumentSalesMutation
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  RevertCompleteTravelDocumentSalesMutation
> {
  return useMutation<
    ApiResult<any>,
    ApiError,
    RevertCompleteTravelDocumentSalesMutation
  >(async function (body) {
    return await MutationFetchFunction({
      url: `document-sales/${body.id}/revert-complete`,
      method: 'PATCH',
    });
  }, options);
}
